import { useCallback } from "react"

import { StorageKeys } from "types/enums/StorageKeys"

import { getStorageItem } from "utils/localStorage"
import { useLogin } from "hooks/useLogin"

export const useEnterpriseMasterAccountSwitch = () => {
  const { login } = useLogin()

  const enterpriseMasterAccountToken = getStorageItem(StorageKeys.EnterpriseMasterAccountToken)
  const hasEnterpriseMasterAccountToken = Boolean(enterpriseMasterAccountToken)

  const switchBackToEnterpriseMasterAccount = useCallback(async () => {
    if (!enterpriseMasterAccountToken) {
      return false
    }

    await login({ accessToken: enterpriseMasterAccountToken, masterToken: null, clearUserProfile: true })
    return true
  }, [enterpriseMasterAccountToken, login])

  return {
    enterpriseMasterAccountToken,
    hasEnterpriseMasterAccountToken,
    switchBackToEnterpriseMasterAccount,
  }
}
